/* globals console, document, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    Uppy = require('@uppy/core'),
    Dashboard = require('@uppy/dashboard'),
    XHRUpload = require('@uppy/xhr-upload'),
    _ = require('lodash'),
    //
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'imagesUpload'
    },
    tagName: 'div',
    template: templates.imagesUpload,
    //
    initialize: function () {
        this.collection = this.options.collection;
        // this.modalModal = this.options.modalModal;
        this.programId = this.options.programId;
        this.uppy = Uppy({
            debug: true,
            autoProceed: false,
            restrictions: {
                maxFileSize: 1000000,
                maxNumberOfFiles: 3,
                minNumberOfFiles: 1,
                allowedFileTypes: ['image/*']
            }
        });
        this.templateContext = this.options.templateContext || {};
        this.render();
    },
    onAttach: function () {
        // console.log('imagesUpload.onAttach - #uppy:%s', jQuery('#uppy').length);
        // console.log('imagesUpload.onAttach');
        this.uppy.use(Dashboard, {
            trigger: '.UppyModalOpenerBtn',
            inline: true,
            target: '#uppy',
            replaceTargetContent: true,
            showProgressDetails: true,
            note: 'Images only, 1–3 files, up to 1 MB',
            height: 300,
            metaFields: [
                { id: 'name', name: 'Name', placeholder: 'file name' },
                { id: 'caption', name: 'Caption', placeholder: 'describe what the image is about' }
            ],
            browserBackButtonClose: true
        });
        this.uppy.use(XHRUpload, {
            endpoint: configuration.apiUrlBase + 'programImage',
            headers: user.authorizationHeader('imagesUpload'),
            formData: true,
            fieldName: 'file'
        });
        this.uppy.on('file-added', _.bind(function (file) {
            console.log(file);
            this.uppy.setFileMeta(file.id, {
                programId: this.programId,
                filename: file.name
            });
        }, this));
        this.uppy.on('complete', _.bind(function () {
            this.collection.fetch();
            // close();
        }, this));
        return this;
    }
    // onRender: function () {
    //     _.defer(function () {
    //         console.log('imagesUpload.onRender - #uppy:%s', jQuery('#uppy').length);
    //     });
    // }
    // onRender: function () {
    //     console.log('imagesUpload.onRender');
    //     _.defer(_.bind(function () {
    //         this.uppy.use(Dashboard, {
    //             trigger: '.UppyModalOpenerBtn',
    //             inline: true,
    //             target: '#uppy',
    //             replaceTargetContent: true,
    //             showProgressDetails: true,
    //             note: 'Images only, 1–3 files, up to 1 MB',
    //             height: 300,
    //             metaFields: [
    //                 { id: 'name', name: 'Name', placeholder: 'file name' },
    //                 { id: 'caption', name: 'Caption', placeholder: 'describe what the image is about' }
    //             ],
    //             browserBackButtonClose: true
    //         });
    //         this.uppy.use(XHRUpload, {
    //             endpoint: configuration.apiUrlBase + 'programImage',
    //             headers: user.authorizationHeader('imagesUpload'),
    //             formData: true,
    //             fieldName: 'file'
    //         });
    //         this.uppy.on('file-added', _.bind(function (file) {
    //             console.log(file);
    //             this.uppy.setFileMeta(file.id, {
    //                 programId: this.programId,
    //                 filename: file.name
    //             });
    //         }, this));
    //         this.uppy.on('complete', _.bind(function () {
    //             this.collection.fetch();
    //             // close();
    //         }, this));
    //     }, this));
    //     return this;
    // }
});
